import ClassElements from './classElements';
import ClassDefault from './classDefault';
import ClassTricky from './classTricky';
import ClassifiedMultiStep from './classifiedMultiStep';
import RealCo from './realCo';

const levelComponents = {
  'class-elements': ClassElements,
  'class-default': ClassDefault,
  'class-tricky': ClassTricky,
  'classified-multistep': ClassifiedMultiStep,
};

// Realco level types follow the `real-public-co-<DisplayName>`
// convention (e.g. `real-public-co-Apple`). Pull the suffix so the
// transition page can highlight the matching company tile.
const REALCO_PREFIX = 'real-public-co';

export default function Classification({
  levelNumber,
  levelType,
  onComplete,
  numberOfAttempts
}) {
  if (levelType?.startsWith(REALCO_PREFIX)) {
    const companyName = levelType.slice(REALCO_PREFIX.length).replace(/^-/, '').trim();
    return (
      <RealCo
        levelNumber={levelNumber}
        onComplete={onComplete}
        numberOfAttempts={numberOfAttempts}
        companyName={companyName}
      />
    );
  }

  const Component = levelComponents[levelType] || ClassElements;

  return (
    <Component
      levelNumber={levelNumber}
      onComplete={onComplete}
      numberOfAttempts={numberOfAttempts}
    />
  );
}
